module.exports = __webpack_public_path__ + "static-v-shop/1791260809989/img/logo_maestro.ced7dab5.png";